import React from "react";
import "../css/Contact.scss";
const Contact = () => {
  return (
    <div className="contact">
      <h1 className="title">Contact</h1>
      <p className="email">
        Email: <a href="mailto: amorntec@gmail.com">amorntec@gmail.com</a>
      </p>
      <p className="linkedIn">
        LinkedIn:
        <a href="https://www.linkedin.com/in/amorntep- yamkasorn-26416b227">
          https://www.linkedin.com/in/amorntep-yamkasorn-26416b227
        </a>
      </p>
      <p className="btn-download-resume">
        <a href="https://drive.google.com/file/d/1VXjPidJ0jG7fFsMK9SpOCljDc9YYnuO5/view?usp=share_link">Download Resume Click!!</a>

      </p>
    </div>
  );
};

export default Contact;
